import { Link } from 'react-router-dom'
import PostMioLogo from '../components/PostMioLogo'

// ── Palette ────────────────────────────────────────────────
const G = {
  bg:      '#0A0A0A',
  card:    '#141414',
  border:  '#2C2C2C',
  gold:    '#C9922A',
  goldLt:  '#E5B050',
  textSec: '#A0A0A0',
  cream:   '#F0EDE8',
  textMut: '#606060',
}

// ── i18n ───────────────────────────────────────────────────
const UI_TEXT = {
  EN: {
    heading: 'Built for small business owners — by one of them.',
    p1: 'My parents ran a restaurant in Germany. Immigrants from Southern Italy. They built something from nothing — but they always struggled with one thing: telling their story.',
    p2: 'No agency. No budget. No time. Just two people working 14-hour days, hoping someone would find them.',
    p3: 'I watched that happen for over 40 years. Then I worked as a Chef across Europe and saw the same problem everywhere — good businesses, invisible online.',
    p4: "I'm Alexander. I built PostMio™ with my own hands. No coding skills, no tech knowledge — just pure necessity and a clear vision.",
    p5: 'Not to get rich. To build the tool my parents never had.',
    cta: 'Start your 7-day free trial →',
    home: 'Home',
    signup: 'Sign up',
  },
  IT: {
    heading: 'Fatto per i piccoli imprenditori — da uno di loro.',
    p1: 'I miei genitori gestivano un ristorante in Germania. Immigrati dalla Calabria. Hanno costruito qualcosa dal nulla — ma hanno sempre fatto fatica con una cosa: raccontare la loro storia.',
    p2: 'Nessuna agenzia. Nessun budget. Nessun tempo. Solo due persone che lavoravano 14 ore al giorno sperando che qualcuno li trovasse.',
    p3: 'Ho guardato succedere per oltre 40 anni. Poi ho lavorato come Chef in tutta Europa e ho visto lo stesso problema ovunque — buone attività, invisibili online.',
    p4: 'Sono Alexander. Ho costruito PostMio™ con le mie mani. Nessuna competenza tecnica, nessuna conoscenza del codice — solo necessità pura e una visione chiara.',
    p5: 'Non per arricchirmi. Per costruire lo strumento che i miei genitori non hanno mai avuto.',
    cta: 'Inizia la prova gratuita di 7 giorni →',
    home: 'Home',
    signup: 'Registrati',
  },
  PL: {
    heading: 'Stworzone przez właściciela małej firmy — dla właścicieli małych firm.',
    p1: 'Moi rodzice prowadzili restaurację w Niemczech. Emigranci z południa Włoch. Zbudowali coś z niczego — ale zawsze mieli problem z jedną rzeczą: opowiadaniem swojej historii.',
    p2: 'Żadnej agencji. Żadnego budżetu. Żadnego czasu. Tylko dwie osoby pracujące po 14 godzin dziennie, mając nadzieję, że ktoś ich znajdzie.',
    p3: 'Patrzyłem na to przez ponad 40 lat. Potem pracowałem jako szef kuchni w całej Europie i wszędzie widziałem ten sam problem — dobre biznesy, niewidoczne online.',
    p4: 'Jestem Alexander. Zbudowałem PostMio™ własnymi rękami. Żadnych umiejętności technicznych, żadnej wiedzy o kodowaniu — tylko czysta potrzeba i wyraźna wizja.',
    p5: 'Nie po to, żeby się wzbogacić. Żeby zbudować narzędzie, którego moi rodzice nigdy nie mieli.',
    cta: 'Zacznij bezpłatny 7-dniowy okres próbny →',
    home: 'Strona główna',
    signup: 'Zarejestruj się',
  },
  ES: {
    heading: 'Creado para pequeños empresarios — por uno de ellos.',
    p1: 'Mis padres tenían un restaurante en Alemania. Inmigrantes del sur de Italia. Construyeron algo de la nada — pero siempre tuvieron dificultades con una cosa: contar su historia.',
    p2: 'Sin agencia. Sin presupuesto. Sin tiempo. Solo dos personas trabajando 14 horas al día, esperando que alguien los encontrara.',
    p3: 'Vi eso suceder durante más de 40 años. Luego trabajé como chef en toda Europa y vi el mismo problema en todas partes — buenos negocios, invisibles en línea.',
    p4: 'Soy Alexander. Construí PostMio™ con mis propias manos. Sin conocimientos de programación, sin conocimientos técnicos — solo necesidad pura y una visión clara.',
    p5: 'No para enriquecerme. Para construir la herramienta que mis padres nunca tuvieron.',
    cta: 'Inicia tu prueba gratuita de 7 días →',
    home: 'Inicio',
    signup: 'Registrarse',
  },
  DE: {
    heading: 'Gebaut für Kleinunternehmer — von einem von ihnen.',
    p1: 'Meine Eltern betrieben ein Restaurant in Deutschland. Einwanderer aus Süditalien. Sie bauten etwas aus dem Nichts — aber hatten immer Schwierigkeiten mit einer Sache: ihre Geschichte zu erzählen.',
    p2: 'Keine Agentur. Kein Budget. Keine Zeit. Nur zwei Menschen, die 14-Stunden-Tage arbeiteten und hofften, dass sie jemand finden würde.',
    p3: 'Ich habe das über 40 Jahre lang beobachtet. Dann arbeitete ich als Koch in ganz Europa und sah dasselbe Problem überall — gute Unternehmen, online unsichtbar.',
    p4: 'Ich bin Alexander. Ich habe PostMio™ mit eigenen Händen gebaut. Keine Programmierkenntnisse, kein technisches Wissen — nur reine Notwendigkeit und eine klare Vision.',
    p5: 'Nicht um reich zu werden. Um das Werkzeug zu bauen, das meine Eltern nie hatten.',
    cta: 'Starten Sie Ihre 7-tägige kostenlose Testversion →',
    home: 'Startseite',
    signup: 'Registrieren',
  },
  FR: {
    heading: 'Créé pour les petits entrepreneurs — par l\'un d\'eux.',
    p1: 'Mes parents tenaient un restaurant en Allemagne. Des immigrés du sud de l\'Italie. Ils ont construit quelque chose de rien — mais ont toujours eu du mal avec une chose : raconter leur histoire.',
    p2: 'Pas d\'agence. Pas de budget. Pas de temps. Juste deux personnes qui travaillaient 14 heures par jour, espérant que quelqu\'un les trouverait.',
    p3: 'J\'ai regardé cela se passer pendant plus de 40 ans. Ensuite, j\'ai travaillé comme chef en Europe et j\'ai vu le même problème partout — de bonnes entreprises, invisibles en ligne.',
    p4: 'Je suis Alexander. J\'ai construit PostMio™ de mes propres mains. Pas de compétences en programmation, pas de connaissances techniques — juste une nécessité pure et une vision claire.',
    p5: 'Pas pour m\'enrichir. Pour construire l\'outil que mes parents n\'ont jamais eu.',
    cta: 'Commencez votre essai gratuit de 7 jours →',
    home: 'Accueil',
    signup: 'S\'inscrire',
  },
}

function detectLang() {
  const l = (navigator.language || '').toLowerCase()
  if (l.startsWith('it')) return 'IT'
  if (l.startsWith('pl')) return 'PL'
  if (l.startsWith('es')) return 'ES'
  if (l.startsWith('de')) return 'DE'
  if (l.startsWith('fr')) return 'FR'
  return 'EN'
}

function renderTM(s) {
  if (typeof s !== 'string' || !s.includes('™')) return s
  const i = s.indexOf('™')
  return <>{s.slice(0, i)}<sup style={{fontSize:'0.5em',verticalAlign:'super',lineHeight:0}}>™</sup>{s.slice(i + 1)}</>
}

const stripeLink = import.meta.env.VITE_STRIPE_LINK_POSTMIO

export default function About() {
  const lang = detectLang()
  const t = UI_TEXT[lang]

  const pStyle = {
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 400,
    fontSize: '1.1rem',
    color: G.cream,
    lineHeight: 1.8,
    margin: 0,
  }

  return (
    <div style={{
      background: G.bg,
      minHeight: '100vh',
      fontFamily: "'DM Sans', sans-serif",
      color: G.cream,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:wght@700&family=DM+Sans:wght@400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${G.bg}; }
      `}</style>

      {/* ── NAVBAR ────────────────────────────────────────── */}
      <nav className="site-nav" style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(10,10,10,0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${G.border}`,
        padding: '0 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 60,
      }}>
        <Link to="/" style={{ textDecoration: 'none', lineHeight: 0 }}>
          <PostMioLogo size="md" variant="dark" />
        </Link>
        <div className="site-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Link to="/" style={{ fontSize: 14, color: G.textSec, textDecoration: 'none', fontWeight: 500, transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = G.cream}
            onMouseLeave={e => e.target.style.color = G.textSec}
          >
            {t.home}
          </Link>
          <Link to="/signup" style={{
            background: G.gold, color: '#0A0A0A',
            padding: '8px 18px', borderRadius: 10,
            fontSize: 13, fontWeight: 700,
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: '0.2px',
            textDecoration: 'none',
            transition: 'background 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = G.goldLt}
            onMouseLeave={e => e.currentTarget.style.background = G.gold}
          >
            {t.signup}
          </Link>
        </div>
      </nav>

      {/* ── MAIN CONTENT ──────────────────────────────────── */}
      <main style={{
        maxWidth: 720,
        margin: '0 auto',
        padding: '80px 24px 96px',
      }}>

        {/* Heading */}
        <h1 style={{
          fontFamily: "'Lora', serif",
          fontWeight: 700,
          fontSize: 'clamp(28px, 5vw, 46px)',
          color: G.gold,
          lineHeight: 1.2,
          marginBottom: 48,
        }}>
          {t.heading}
        </h1>

        {/* Paragraphs */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <p style={pStyle}>{t.p1}</p>
          <p style={pStyle}>{t.p2}</p>
          <p style={pStyle}>{t.p3}</p>
          <p style={pStyle}>{renderTM(t.p4)}</p>
          <p style={pStyle}>{t.p5}</p>
        </div>

        {/* Gold divider */}
        <hr style={{
          border: 'none',
          borderTop: `1px solid ${G.gold}`,
          margin: '56px 0',
          opacity: 0.5,
        }} />

        {/* CTA */}
        <div style={{ textAlign: 'center' }}>
          <a
            href={stripeLink}
            style={{
              background: '#C9922A',
              color: '#0A0A0A',
              padding: '16px 40px',
              borderRadius: '10px',
              fontSize: '17px',
              fontWeight: 700,
              border: 'none',
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: '0.2px',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'default',
              opacity: 0.6,
              pointerEvents: 'none',
            }}
          >
            🚀 Coming Soon — Stay tuned for launch!
          </a>
        </div>
      </main>

      {/* ── FOOTER ────────────────────────────────────────── */}
      <footer style={{
        borderTop: `1px solid ${G.border}`,
        padding: '32px 24px',
        textAlign: 'center',
      }}>
        <p style={{
          fontSize: '0.85rem',
          color: G.textSec,
          fontFamily: "'DM Sans', sans-serif",
          fontWeight: 400,
        }}>
          By a small business owner - for small business owners
          {' · '}
          <Link to="/reviews" style={{ color: G.textMut, textDecoration: 'none' }}>
            {lang === 'IT' ? 'Recensioni' : lang === 'PL' ? 'Opinie' : 'Reviews'}
          </Link>
          {' · '}
          <Link to="/privacy" style={{ color: G.textMut, textDecoration: 'none' }}>
            Privacy Policy
          </Link>
        </p>
      </footer>
    </div>
  )
}
